import { render } from "./ChallengePlayerActive.vue?vue&type=template&id=0c96a32b"
import script from "./ChallengePlayerActive.vue?vue&type=script&lang=js"
export * from "./ChallengePlayerActive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__